module.exports = __webpack_public_path__ + "img/kr-card-bottom-1.5b447c5.png";